import httpClient, { handleSuccess, handleError, apiHeader } from './httpClient'

export function getPfDataURL(formData) {
  const params = new URLSearchParams()
  return httpClient.post('profile/getPfDataURL', params, apiHeader).then(handleSuccess).catch(handleError)
}

export function info() {
  const params = new URLSearchParams()
  return httpClient
    .get('profile/info', {
      params
    })
    .then(handleSuccess)
    .catch(handleError)
}

export async function update(formData) {
  const params = new URLSearchParams()
  if (formData.display_name === null) {
    params.append('display_name', '')
  } else {
    params.append('display_name', formData.display_name)
  }
  params.append('address_prefecture', formData.address_prefecture)
  params.append('birth_year', formData.birth_year)
  params.append('birth_month', formData.birth_month)
  if (formData.introduction === null) {
    params.append('introduction', '')
  } else {
    params.append('introduction', formData.introduction)
  }
  if (formData.url_string === null) {
    params.append('url_string', '')
  } else {
    params.append('url_string', formData.url_string)
  }
  params.append('pfIcoDataURL', formData.pfIcoDataURL)
  params.append('pfBgDataURL', formData.pfBgDataURL)

  return httpClient.post('profile/update', params, apiHeader).then(handleSuccess).catch(handleError)
}
